<mat-dialog-content>
  <form [formGroup]="userForm">
    <h2>
      <strong>{{ 'Modify User' | translate }}</strong>
    </h2>
    <div class="text-margin">
      <span
        ><strong>{{ 'Name' | translate }}:</strong></span
      >
      <input
        class="form-control"
        type="text"
        placeholder="{{ 'Full name' | translate }}"
        formControlName="name"
      />
      @if (textValid('name')) {
        <span class="form-text text-danger">{{
          'You must type only a name and a lastname' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Email' | translate }}:</strong></span
      >
      <input
        class="form-control"
        type="text"
        placeholder="{{ 'Email' | translate }}"
        formControlName="email"
      />
      @if (textValid('email')) {
        <span class="form-text text-danger">{{
          'You must type a valid email' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Document Type' | translate }}:</strong></span
      >
      <select
        class="form-control"
        formControlName="types_docs"
        [compareWith]="compareDocType"
      >
        @for (types of documenTypeList; track types) {
          <option [ngValue]="types">
            {{ types.description }}
          </option>
        }
      </select>
      @if (textValid('types_docs')) {
        <span class="form-text text-danger">{{
          'You must select a type' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Document' | translate }}:</strong></span
      >
      <input
        maxlength="9"
        class="form-control"
        type="text"
        placeholder="{{ 'Document' | translate }}"
        formControlName="document"
      />
      @if (textValid('document')) {
        <span class="form-text text-danger">{{
          'You must type only numbers' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Rol' | translate }}:</strong></span
      >
      <select
        class="form-control"
        formControlName="rol"
        [compareWith]="compareRol"
      >
        @for (rol of rolList; track rol) {
          <option [ngValue]="rol">
            {{ rol.name }}
          </option>
        }
      </select>
      @if (textValid('rol')) {
        <span class="form-text text-danger">{{
          'You must select a rol' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <button
        style="width: 100%"
        mat-raised-button
        (click)="dialogAddCompany(true, this.id_user)"
      >
        {{ 'Manage Companyes' | translate }}
      </button>
    </div>
    <div
      class="row"
      style="padding-left: 20px; margin-top: 10px"
      id="buttons-div"
    >
      <div class="col">
        <button mat-raised-button (click)="update()">
          {{ 'Modify' | translate }}
        </button>
      </div>
      <div class="col">
        <button mat-raised-button [mat-dialog-close]>
          {{ 'Cancel' | translate }}
        </button>
      </div>
    </div>
  </form>
</mat-dialog-content>
